import { Dayjs } from 'dayjs';

const parseDateNumber = (n: number) => n < 10 ? `0${n}` : n;

export const parseDate = (date: Dayjs) => {
  const day = date.date();
  const month = date.month() + 1;
  const year = date.year();
  return `${year}-${parseDateNumber(month)}-${parseDateNumber(day)}`;
}; 